const normalizePath = (path) => {
  if (!path) return "/";
  if (path.startsWith("http")) return path;
  return path.startsWith("/") ? path : `/${path}`;
};

const RAW_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://3umipjds5v.eu-central-1.awsapprunner.com/";
const API_BASE_URL = RAW_API_BASE_URL.replace(/\/$/, "").replace(/\/api$/, "");

const getRequestId = (response) => {
  if (!response?.headers) return null;
  return (
    response.headers.get("x-request-id") ||
    response.headers.get("x-amzn-trace-id") ||
    response.headers.get("x-amzn-requestid")
  );
};

const apiFetch = async (path, options = {}) => {
  const url = `${API_BASE_URL}${normalizePath(path)}`;

  const extraHeaders = options.headers instanceof Headers
    ? Object.fromEntries(options.headers.entries())
    : options.headers || {};

  const { headers: _ignoredHeaders, ...restOptions } = options;
  const method = (restOptions.method || "GET").toUpperCase();

  let response;
  try {
    response = await fetch(url, {
      ...restOptions,
      headers: {
        "Content-Type": "application/json",
        ...extraHeaders,
      },
    });
  } catch (err) {
    const networkError = new Error(
      `Unable to reach the API for ${method} ${url}. Please check your connection or backend server.`
    );
    networkError.cause = err;
    networkError.status = 0;
    networkError.url = url;
    networkError.method = method;
    networkError.errorCode = "NETWORK_ERROR";
    throw networkError;
  }

  const requestId = getRequestId(response);
  const text = await response.text();
  let data;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (_err) {
    data = text;
  }

  if (!response.ok) {
    const serverErrorCode = data?.errorCode;
    const shouldUseServerMessage =
      response.status < 500 ||
      serverErrorCode === "CONFIG_MISSING" ||
      serverErrorCode === "DB_UNAVAILABLE";
    const baseMessage = shouldUseServerMessage
      ? data?.message || data?.error || response.statusText || "API request failed"
      : `API returned ${response.status}`;
    const message = requestId ? `${baseMessage} (request id: ${requestId})` : baseMessage;
    const error = new Error(`${message} for ${method} ${url}`);
    error.status = response.status;
    error.data = data;
    error.url = url;
    error.method = method;
    error.requestId = requestId;
    error.errorCode = data?.errorCode || "API_ERROR";
    throw error;
  }

  return data;
};

export { API_BASE_URL, apiFetch };
